var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHangup = function SvgHangup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 28",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.842 1.964A3.534 3.534 0 0 1 9.885.25h12.23c1.248 0 2.41.647 3.043 1.714l6.116 10.306a3.383 3.383 0 0 1 0 3.46L25.16 26.036a3.535 3.535 0 0 1-3.043 1.714H9.884a3.534 3.534 0 0 1-3.042-1.714L.726 15.73a3.384 3.384 0 0 1 0-3.46L6.842 1.965Zm1.29.766L2.016 13.036a1.883 1.883 0 0 0 0 1.93L8.13 25.27c.357.6 1.023.98 1.753.98h12.232c.73 0 1.395-.379 1.753-.98m0 0 6.115-10.305a1.883 1.883 0 0 0 0-1.93L23.869 2.73a2.035 2.035 0 0 0-1.753-.98H9.885c-.731 0-1.397.38-1.753.98"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hangup_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.405 8.595a.75.75 0 0 1 0 1.06L17.061 14l4.344 4.345a.75.75 0 1 1-1.06 1.06L16 15.061l-4.345 4.344a.75.75 0 1 1-1.06-1.06L14.939 14l-4.344-4.345a.75.75 0 0 1 1.06-1.06L16 12.94l4.345-4.345a.75.75 0 0 1 1.06 0Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hangup_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7 5)",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgHangup;